import AppTooltip from "../tooltip";

export const ConditionalTooltip = ({ condition, value, children }) => {
  return condition ? (
    <AppTooltip content={value}>{children}</AppTooltip>
  ) : (
    children
  );
};
